<template>
    <b-field :label="$t('misc.selectUnits')">
        <b-taginput
            v-model="selectedUnitTags"
            :data="filteredUnitTags"
            autocomplete
            :allow-new="false"
            :open-on-focus="true"
            ellipsis
            icon="label"
            :placeholder="$t('misc.addUnit')"
            type="is-primary"
            @typing="getFilteredUnitTags">
        </b-taginput>
    </b-field>
</template>

<script>

import { formatUnitName } from "@/utils/format";

export default {
    name: "UnitsField",
    data: function () {
        return {
            unitTags: [],
            selectedUnitTags: [],
            filteredUnitTags: []
        }
    },
    props: {
        units: Array
    },
    watch: {
        units: function (units) {
            this.unitTags = units.map(formatUnitName);
        }
    },
    methods: {
        clear () {
            this.selectedUnitTags = [];
        },
        getFilteredUnitTags (text) {
            let availableUnits = this.unitTags.filter((unit) => {
                return !(this.selectedUnitTags.includes(unit))
            });

            this.filteredUnitTags = availableUnits.filter((unit) => {
                return unit
                    .toString()
                    .toLowerCase()
                    .indexOf(text.toLowerCase()) >= 0
            })
        },
        setSelectedUnits (units) {
            this.selectedUnitTags = units.map(formatUnitName);
        },
        getChosenUnits () {
            let fieldView = this;

            return this.units.filter((unit) => {
                return fieldView.selectedUnitTags.includes(formatUnitName(unit));
            });
        }
    }
}

</script>